var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { animated } from '@react-spring/web';
import { useSpringValues } from '../hooks/use-spring-values';
var cls = classNames('svg-exclude-mask');
export var SvgExcludeMaskDefaultProps = {
  x: 0,
  y: 0
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var MaskStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var RectStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.defs(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Mask: styled.mask(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), MaskStyles),
  Rect: styled(animated.rect)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), RectStyles)
};
export var SvgExcludeMask = function (props) {
  var className = props.className,
    id = props.id,
    children = props.children;
  var values = useSpringValues(props);
  return React.createElement(My.Container, {
    className: className
  }, React.createElement(My.Mask, {
    id: id
  }, React.createElement(My.Rect, {
    x: values.x,
    y: values.y,
    fill: "#FFFFFF",
    width: values.width,
    height: values.height
  }), children));
};
SvgExcludeMask.cls = cls;
SvgExcludeMask.defaultProps = SvgExcludeMaskDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;